import React, { FC } from 'react';
import styled from 'styled-components';

import { colorStack } from '../../../styleHelpers/colors';

const Wrapper = styled.div`
    width: 100%;
    height: 2px;
    border-radius: 20px;
    background: ${colorStack.ligthGrey};
`;

interface IProps {
    className?: string;
}

export const LineSeparator: FC<IProps> = props => {
    return (
        <Wrapper className={props.className} />
    );
};